import type { NotificationResponse } from '@/types/notification';

export function isNotificationUnread(notification: NotificationResponse): boolean {
  return notification.readFlag !== true;
}

export function formatNotificationTime(createdAt?: string): string {
  if (!createdAt) return '—';
  return new Date(createdAt).toLocaleString();
}
